import { Box, Breadcrumbs, Typography } from '@mui/material';
import auth from '@client/components/auth';
import { Link } from 'react-router';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PATHS } from '@client/routes';

const breadcrumbsCommunity = (influencer?: string) => [
  <Typography key="creators">Creators</Typography>,
  <Typography
    key="influencer"
    color="text.primary"
  >{`${influencer}'s feed`}</Typography>,
];

const breadcrumbsPost = (
  communityId: number,
  influencerId: number,
  influencer?: string,
) => [
  <Typography key="creators">Creators</Typography>,
  <Link
    key="influencer"
    className="text-gray-2 font-normal"
    to={PATHS.COMMUNITY(influencerId, communityId)}
  >
    <Typography>{`${influencer}'s feed`}</Typography>
  </Link>,
  <Typography key="post" color="text.primary">
    Post
  </Typography>,
];

export const CommunityPageHeader = ({
  influencerId,
  communityId,
  postId,
  ownerName,
}: {
  influencerId: number;
  ownerName: string;
  communityId: number;
  postId?: string;
}) => {
  const isAdmin = auth.isAdministrator();

  return (
    <>
      {isAdmin ? (
        <Breadcrumbs
          className="pb-5"
          separator={
            <FontAwesomeIcon className="text-bold" icon={faChevronRight} />
          }
          aria-label="breadcrumb"
        >
          {postId
            ? breadcrumbsPost(communityId, influencerId, ownerName)
            : breadcrumbsCommunity(ownerName)}
        </Breadcrumbs>
      ) : (
        <Box className="max-w-[680px] m-auto">
          {postId ? (
            <div className="pb-3.5">
              <Link
                className="text-gray-2 font-normal"
                to={PATHS.COMMUNITY(influencerId, communityId)}
              >
                ← back
              </Link>
            </div>
          ) : (
            <Typography variant="h4" className="pb-5 font-bold">
              Community
            </Typography>
          )}
        </Box>
      )}
    </>
  );
};
